import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MinistryClient,
  MinistryDto,
  CreateMinistryDto,
  UpdateMinistryDto,
  UpdateMinistrySortOrderDto,
} from '../generated/api-client';

@Injectable({ providedIn: 'root' })
export class MinistryApiService {
  constructor(private readonly client: MinistryClient) {}

  getAll(): Observable<MinistryDto[]> {
    return this.client.getAll();
  }

  getById(id: number): Observable<MinistryDto> {
    return this.client.getById(id);
  }

  create(dto: CreateMinistryDto): Observable<MinistryDto> {
    return this.client.create(dto);
  }

  update(id: number, dto: UpdateMinistryDto): Observable<void> {
    return this.client.update(id, dto);
  }

  delete(id: number): Observable<void> {
    return this.client.delete(id);
  }

  updateSortOrder(id: number, dto: UpdateMinistrySortOrderDto): Observable<void> {
    return this.client.updateSortOrder(id, dto);
  }
}
